import { IEnvironment } from './environment.interface';
import { version } from './version';

export const environment: IEnvironment = {
  version,
  production: false,
  mock: false,
  authIdleTimeoutSeconds: 1800,
  url_backend: 'https://backend-dev.practice-mgmt-dev.com/',
  url_servicios: 'https://backend-dev.practice-mgmt-dev.com/api',
  url_frontend: 'https://app-dev.practice-mgmt-dev.com/',
  url_media: 'https://backend-dev.practice-mgmt-dev.com/storage/',
  showProductionWarning: false,
  serviceWorkerEnabled: true,

  //   url_backend: 'http://127.0.0.1:8000/',
  // url_servicios: 'http://127.0.0.1:8000/api',
  // url_frontend: 'http://localhost:4200/',
  // url_media: 'http://127.0.0.1:8000/storage/',
};
